import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  minScrollHeight: 100,
};

const layout = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setLayout: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearLayout: () => {
      return initialState;
    },
  },
});

// Export actions and reducer
export const { setLayout, clearLayout } = layout.actions;
export default layout.reducer;
